import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Moment from 'react-moment';
import moment from 'moment';

import Grid from '@mui/material/Grid';

import Select from '@mui/material/Select';

import FormControl from '@mui/material/FormControl';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

const headCells = [


 
  { id: 'leavetype', numeric: false, label: 'Type' },
  { id: 'applieddate', numeric: false, label: 'Applied Date' },
  
  { id: 'lm_fromdate', numeric: false, label: 'From Date' },
  { id: 'lm_todate', numeric: false, label: 'To Date' },
  
  
  { id: 'lm_details', numeric: false, label: 'Details' },
  { id: 'leavestatus', numeric: false, label: 'Status' },
  { id: 'lm_comments', numeric: false, label: 'Comments' },
  
   { id: '',  label: '' },
  ]
  
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class  Applyleave extends Component {


 constructor(props) {
    super(props);

   
	 
	 
    this.state = { redirect:false,leavedata:[],lmid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
	  order:'desc' ,orderby:'lm_id',title:'',type:'',unit:'',search:'',
	  lvstatus:'',	  

          
	};
   //this.updateDonenewParent = this.updateDonenewParent;
}

updateDonenewParent = (text) => {this.componentDidMount();  }
	componentDidUpdate() {
		
  if(this.state.prevpage !== this.state.page) {
    this.setState({   prevpage: this.state.page});
  this.apicall(this.state.page, localStorage.getItem("page"));  
  }
}


myChangeHandler = (event) => {
	  
  let nam = event.target.name;
  let val = event.target.value;
    
  this.setState({[nam]: val});
  
  
}
componentDidMount() {
	
	
		
		   if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
		


	
		  document.title = "Athayoga Living - Apply Leave";
	
	
	  localStorage.setItem("page",this.state.rowsPerPage);


	  axios.get(Serverurl+'ajaxleaves.php?action=list&lm_type='+this.state.type+'&lm_createduserid=1&Sorting='+this.state.orderby+' '+this.state.order+'&StartIndex=0&PageSize=10')

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  leavedata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   rowsPaging:[],
			  
		    });	
			
		let copy=[50,100,150,200,250];	
	  
	  this.setState({rowsPaging:copy  });	 
     }
	 
	 else{
		   this.setState({leavedata:[],totaldata:0});
	 }
  
    });

}








apicall(page,rowsPerPage){
	  axios.get(Serverurl+'ajaxleaves.php?action=list&lm_type='+this.state.type+'&fromdate='+this.state.fdate1+'&todate='+this.state.tdate1+'&lm_createduserid=1&lm_status='+this.state.lvstatus+'&Sorting='+this.state.orderby+' '+this.state.order+'&StartIndex='+page+'&PageSize='+rowsPerPage)

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  leavedata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   rowsPaging:[],
			  
		    });	
			
		let copy=[50,100,150,200,250];	
	  
	  this.setState({rowsPaging:copy  });	 
     }
	 
	 else{
		   this.setState({leavedata:[],totaldata:0});
	 }
  
    });
}
 
leaveDelete(lmid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','leavedelete')
	 formData.append('lm_id',lmid)
	 formData.append('userid',1)
	
	 axios.post(Serverurl+"ajaxleaves.php", formData, {
        }).then(res => {
    
             this.setState({  
      prevpage: -1,
    
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  
    
            });
 }
}
     
	 Itemaddbox(val){
        this.setState({ lmid: val });  
  
         setTimeout(() => this.refs.AddItembox.handleClickOpen(),500);

      }
	  
	  
	  
leaveCancel(lmid,lvtype){  
	
let r = window.confirm("Do you really want to Cancel?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','leavecancel')
	 formData.append('lm_id',lmid)
	 formData.append('lm_status',3)
	 formData.append('lm_type',lvtype)
	 formData.append('userid',1)
	 
	
	 axios.post(Serverurl+"ajaxleaves.php", formData, {
        }).then(res => {
    
             this.setState({  
      prevpage: -1,
    
    });
   
 
    setTimeout(() =>  this.componentDidMount() ,500); 
  
    
            });
 }
      }

  
handleChangePage = (event, newPage) => {  
   
     
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  };  
  
   handleChangeRowsPerPage = event => {  
   
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)
    setTimeout(() =>  this.componentDidUpdate() ,500);
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    }); 
  }; 
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};
  
  

  
 handfrChange = (Dayjs) => {
	 var month="";
	var date=new Date(Dayjs);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
     this.setState({ fdate:date,
fdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }  
    
handtoChange = (Dayjs) => {
	  var month="";
	 var date=new Date(Dayjs);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)} 
	 
	  var strtotime=this.state.fdate1.split(' ');
	 
	if(strtotime[0]>date.getFullYear() + '-' + month + '-' +date.getDate())
	{
		 var strtoday=this.state.fdate1.split('-');
		 if(strtoday[0]>date.getFullYear() && strtoday[1]>month && strtoday[2]>date.getDate())
	{
	alert("Please Select To date greater than equal to")
	return false;
	}
	}
	 
     this.setState({ tdate:date,
tdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }


  

handleSubmit= (event) => {
    
    event.preventDefault();
	
	let fdate1 = this.state.fdate1;
	let tdate1 = this.state.tdate1;
	let maname = this.state.maname;
	let mtname = this.state.mtname;
	let type = this.state.type;
	let invoice = this.state.invoice;
	let receive = this.state.receive;
	let lvstatus = this.state.lvstatus;
	
	this.apicall(this.state.page,this.state.rowsPerPage);
	
	
} 


handfrChange = (Dayjs) => {
	 var month="",date1="";
	 var date=new Date(Dayjs);
	 alert(date.getMonth() + 1);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
	 
	 
	  if((date.getDate() )<10)
	 {
		date1="0"+ (date.getDate() )		 
	 }else{date1=(date.getDate())}
	
     this.setState({ fromdate:date,
fromdate1:date.getFullYear() + '-' + month + '-' +date1
	 })
	
	
  }
handfrmChange=(Dayjs)=> {
	 
	var month="",date1="";
	 var date=new Date(Dayjs);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
	 
	 
	  if((date.getDate() )<10)
	 {
		date1="0"+ (date.getDate() )		 
	 }else{date1=(date.getDate())}
	 
	 
     this.setState({ todate:date,
todate1:date.getFullYear() + '-' + month + '-' +date1
	 })
	
	
  }  
 
  
render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
return (
				
					
<React.Fragment>
<div className="contentmain">
<div className="boxheading">
				  <div className="contntpad">
<h2>Leave Management</h2>
</div>
</div>

 <div className="searchmaster">
  <ul>
  <li>

 <p><LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
        <DemoItem label="From Date">
          <DatePicker id="fromdate1" name="fromdate"
		  value={this.state.fromdate1 || dayjs(Date.now())} onChange={this.handfrChange}
		
            views={['year', 'month', 'day']}
		  />
        </DemoItem>
       
      </DemoContainer>
    </LocalizationProvider>
		
		</p></li>
<li>
	
	  <p>
		<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
        <DemoItem label="To Date">
          <DatePicker id="todate1" name="todate"
		  value={this.state.todate1 || dayjs(Date.now())} onChange={this.handfrmChange}
		
            views={['year', 'month', 'day']}
		  />
        </DemoItem>
       
      </DemoContainer>
    </LocalizationProvider>
	
		</p> </li>
		

<li>	
		  
		  <p> <FormControl  className="stadrp">
       
        <Select
		variant="outlined"
        native
         value={this.state.type}
          onChange={this.myChangeHandler}
        name='type'
         id='type'
		 fullWidth
		 
        >
		   
          <option value={''}>Select Type</option>
          <option value={1}>Permission</option>
          <option value={2}>Leave</option>
		  
          </Select>
      </FormControl>
		  	   </p>
			   </li>
			   
			

<li>
 <p> <FormControl  className="stadrp">
       
        <Select
		variant="outlined"
        native
         value={this.state.lvstatus}
          onChange={this.myChangeHandler}
        name='lvstatus'
         id='lvstatus'
		 fullWidth
		 
        >
		   
          <option value={''}>Select Status</option>
		  <option value={0}>Waiting For Approval</option>
          <option value={1}>Approved</option>
          <option value={2}>Rejected</option>
		  <option value={4}></option>
          </Select>
      </FormControl>
		  	   </p>
</li>



			
		<li>
	
		<p>
		
		<Button variant="contained" onClick={this.handleSubmit} className="frmPrimarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>
			&nbsp;
	  <Button variant="contained" onClick={()=>{this.Itemaddbox(0)}} className="frmPrimarybtn" endIcon={<AddIcon />}>
        New
      </Button></p>  

</li>
			   
			   
			   
  </ul>
  </div>

<div className="backbutton">
<div className="note">
<p> <span style={{"color":"red"}}>*Note : </span>  &nbsp;&nbsp; - Leave, &nbsp;&nbsp;  - Cancel </p>

</div>
</div>
<div className="clear"></div>


<Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}>  
  
  
 
  
                <Table stickyHeader aria-label="sticky table">  

					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.leavedata.length}
            />
                      <TableBody>
                     {(this.state.leavedata).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >


{item.lm_type === "1"  && (  <React.Fragment>
 <TableCell>{item.leavetype}</TableCell>
  </React.Fragment>)}
  
 {item.lm_type === "2"  && (  <React.Fragment>
 <TableCell>{item.leavetype}</TableCell>
  </React.Fragment>)} 
  
 
 
  <TableCell>{item.applieddate}</TableCell>
 {item.lm_type === "2"  && (  <React.Fragment>
<TableCell>{item.lm_fromdate}</TableCell>
<TableCell>{item.lm_todate}</TableCell>

  </React.Fragment>)}
 

{item.lm_type === "1"  && (   <React.Fragment>
<TableCell>{item.fromtime}</TableCell>
<TableCell>{item.totime}</TableCell>

  </React.Fragment>)}




<TableCell>{item.lm_details}</TableCell>
<TableCell>{item.leavestatus}</TableCell>
<TableCell>{item.lm_comments}</TableCell>
<TableCell align="left">
<div className="actionbtns">


{item.lm_status === "0" && (  <React.Fragment>


<Button variant="contained" className="frmPrimarybtn" onClick={()=>{this.Itemaddbox(item.lm_id)}} endIcon={<EditIcon />}>
Edit
</Button>

 
 
  &nbsp;  &nbsp;

<Button variant="contained" className="frmPrimarybtn" onClick={()=>{this.leaveDelete(item.lm_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button>


 
</React.Fragment> )}


{item.lm_status === "1" && (  <React.Fragment>


<Button variant="contained" className="frmPrimarybtn" onClick={()=>{this.leaveCancel(item.lm_id,item.lm_type)}} endIcon={<DeleteIcon />}>
  Cancel
</Button>




</React.Fragment> )}




 </div>


 </TableCell>
 </TableRow>

        </React.Fragment>	
				);
					})}
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="7">No Records</TableCell>
					</TableRow>
					) }
                      </TableBody>


</Table>
  </TableContainer> 
 <TablePagination  
        rowsPerPageOptions={this.state.rowsPaging}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onChangePage={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />    
  </Paper>
    </div>



</React.Fragment>

     );
    }
   }


